<template>
  <div>
    <h3 class="heading-3 mt-7">{{ i18n(translations.title) }}</h3>
    <p class="text-static-default-low body-1 mt-12">
      {{ i18n(translations.subTitle) }}
    </p>
    <RevList class="mt-32" :hasExternalBorders="false" interactive>
      <RevListItemInteractive
        v-for="item in userInfoList"
        :key="item.id"
        @click="displayForm(item.id)"
      >
        <template #prefix v-if="item.prefix">
          <component :is="item.prefix" class="text-action-success-hi" />
        </template>

        <template #label>
          {{ item.title }}
        </template>

        <template #description v-if="item.requiredLabel">
          {{ item.requiredLabel }}
        </template>

        <template #suffix v-if="item.suffix">
          <component :is="item.suffix" />
        </template>
      </RevListItemInteractive>
    </RevList>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  PAYMENT_INFOS_TYPES,
  type PaymentInfosTypesType,
} from '@backmarket/http-api/src/api-specs-buyback/customer/client'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevList } from '@ds/components/List'
import { RevListItemInteractive } from '@ds/components/ListItemInteractive'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import { IconPlus } from '@ds/icons/IconPlus'

import kycTranslations from '../KycDetailsModal.translations'

import translations from './Intro.translations'

const i18n = useI18n()
const emit = defineEmits<{
  next: [id: PaymentInfosTypesType]
}>()
const props = defineProps<{
  hasIdentityInformations: boolean
  hasIdentity: boolean
  hasBirthdate: boolean
  hasBankDetails: boolean
  paymentTypes: PaymentInfosTypesType[] | undefined
}>()

const sections = props.paymentTypes?.map((type) => type) || []

const introSection = computed(() => ({
  [PAYMENT_INFOS_TYPES.BANK_DETAILS]: {
    title: translations.bankTitle,
    completed: props.hasBankDetails,
  },
  [PAYMENT_INFOS_TYPES.PERSONAL_IDENTIFICATION]: {
    title: kycTranslations.identityInformationsTitle,
    completed: props.hasIdentityInformations,
  },
  [PAYMENT_INFOS_TYPES.TAX_IDENTIFICATION_NUMBER]: {
    title: kycTranslations.identityInformationsTitle,
    completed: props.hasIdentityInformations,
  },
  [PAYMENT_INFOS_TYPES.DATE_OF_BIRTH]: {
    title: translations.birthdateTitle,
    completed: props.hasBirthdate,
  },
  [PAYMENT_INFOS_TYPES.IDENTITY_DOCUMENT]: {
    title: translations.idTitle,
    completed: props.hasIdentity,
  },
}))

const userInfoList = computed(() => {
  const infoList: Array<{
    id: PaymentInfosTypesType
    title: string
    requiredLabel: string | null
    prefix: object | ''
    suffix: object
  }> = []

  sections.forEach((value) => {
    const currentSection = introSection.value[value]
    infoList.push({
      id: value,
      title: i18n(currentSection.title),
      requiredLabel: !currentSection.completed
        ? i18n(translations.requiredLabel)
        : null,
      prefix: currentSection.completed ? IconCheckInCircle : '',
      suffix: !currentSection.completed ? IconPlus : IconChevronRight,
    })
  })

  return infoList
})

function displayForm(id: PaymentInfosTypesType) {
  emit('next', id)
}
</script>
